<div class="skeleton" aria-busy="true" aria-label="Loading partner scorecard">
  <ngx-skeleton-loader
    class="skeleton__month"
    *ngFor="let card of monthCards; trackBy: trackByIndex"
    count="1"
    appearance="line"
    [theme]="monthTheme"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    class="skeleton__declined"
    count="1"
    appearance="line"
    [theme]="declinedTheme"
  ></ngx-skeleton-loader>
</div>
